import Keycloak from 'keycloak-js';
import { APP_CONFIG } from 'appConfig';
import { realms, clients } from './realms';

const domain = window.location.host.split('.')[0];
const realm = domain in realms ? realms[domain] : undefined;
const client = domain in clients ? clients[domain] : 'core_frontend';

if (!realm) {
  window.location = APP_CONFIG.extWebsite;
}

const urlParams = new URLSearchParams(window.location.search);
export const userName = urlParams.get('u');

const keycloak = new Keycloak({
  url: APP_CONFIG.kcAuth,
  realm: realm,
  clientId: client,
});

export default keycloak;
